module.exports = __webpack_public_path__ + "static/img/fish2.540943e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish2.png
// module id = q9A3
// module chunks = 0